import { BaseService } from '../../infra/base.service'
import type { ScheduleGroupsRepository } from './schedule-groups.repository'
import type { ScheduleGroupEntity } from './schedule-group.entity'

export class ScheduleGroupsService extends BaseService<ScheduleGroupEntity> {
    constructor(private rep: ScheduleGroupsRepository) {
        super(rep)
    }
}
